import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";
import Modal from "react-bootstrap/Modal";
import attachedLogo from "../../assets/images/attached.png";

const ViewEmailLogModal = (props) => {
  const closeModal = () => {
    props.setIsModalOpen(false);
  };

  useEffect(() => {
    if (props.isModalOpen) {
      const modalBody = document.querySelector(".modal-body");
      if (modalBody) {
        const buttons = modalBody.querySelectorAll("button");
        buttons.forEach((button) => {
          // Remove existing click events
          button.onclick = (e) => e.preventDefault();

          // Optionally, add a class to indicate "read-only" state
          button.classList.add("readonly-button");
        });
      }
    }
  }, [props.isModalOpen]);

  const emailData = props.emailData;

  return (
    <>
      <Modal
        show={props.isModalOpen}
        onHide={closeModal}
        backdrop="static"
        size="xl"
      >
        <div className="modal-header">
          <h4 className="modal-title">View Email Details</h4>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={closeModal}
          ></button>
        </div>

        <div className="modal-body">
          {emailData ? (
            <form className="details-form details-form-right p-0">
              <div className="d-flex justify-content-between mb-3 email-title-border">
                <div className="view-email-title">
                  <div className="d-flex res-flex-col flexalign-center">
                    <label className="mb-1 w-auto">Subject: </label>
                    <span className="view-email-subject">
                      {emailData.subject}
                    </span>
                  </div>
                </div>
                <div>
                  {" "}
                  <span className="badge bg-opacity-10 closed-color r-view">
                    {emailData.status}
                  </span>
                </div>
              </div>

              <div className="row">
                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12">
                  <div className="form-group">
                    <label className="mb-1">Email Type: </label>
                    <p>{emailData.emailType}</p>
                  </div>
                </div>

                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12">
                  <div className="form-group">
                    <label className="mb-1">Email From: </label>
                    <p>{emailData.emailFrom}</p>
                  </div>
                </div>

                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12">
                  <div className="form-group">
                    <label className="mb-1">Email To: </label>
                    <p>{emailData.emailTo}</p>
                  </div>
                </div>

                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12">
                  <div className="form-group">
                    <label className="mb-1">Date & Time: </label>
                    <p>
                      {emailData?.createdAt.formattedTime},{" "}
                      {emailData?.createdAt.formattedDate}
                    </p>
                  </div>
                </div>

                {emailData && emailData.attachments?.length > 0 && (
                  <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12">
                    <div className="form-group">
                      <label className="mb-1">Attachment:</label>

                      <div className="d-flex mt-2 email-attach">
                        <img
                          className="clipboard"
                          src={attachedLogo}
                          alt="attachments"
                        />

                        <ul className="mb-0">
                          {emailData.attachments.map((file, index) => (
                            <li key={file._id ?? index}>
                              <a
                                href={file.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="attached-file-name text-blue-600 underline"
                              >
                                {file.filename}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                )}

                <div className="mt-3">
                  <span
                    className="message-preview emaillog-modal-preview table-responsive"
                    dangerouslySetInnerHTML={{ __html: emailData.body }}
                  />
                </div>
              </div>
            </form>
          ) : (
            <p>Loading Email details...</p>
          )}
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={closeModal}
            className="add-minutes Mom-btn"
          >
            <p>Close</p>
          </button>
        </div>
      </Modal>
    </>
  );
};

export default ViewEmailLogModal;
